/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finance_Nav_OverviewInputs */

const en_finance_nav_overview = /** @type {(inputs: Finance_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const pl_finance_nav_overview = /** @type {(inputs: Finance_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Finance_Nav_OverviewInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const finance_nav_overview = /** @type {((inputs?: Finance_Nav_OverviewInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finance_Nav_OverviewInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_finance_nav_overview(inputs)
	return en_finance_nav_overview(inputs)
});